/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime: 2020-01-09 17:25:19
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\networkResource\myResources\myResources_router.js
 * @Description:
 */
'use strict';
angular.module('myResourcesRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.myresources.subscriptionfolder', {
                url: '/subscriptionfolder',
                views: {
                    'main@front.networksource.myresources': {
                        templateUrl: './networkResource/myResources/subscriptionFolder/subscriptionFolder_tpl.html',
                        controller: 'subscriptionFolderCtrl',
                    },
                },
            })
            .state('front.networksource.myresources.subscriptionfolderson', {
                url: '/subscriptionfolderson?groupid',
                views: {
                    'main@front.networksource.myresources': {
                        templateUrl: './networkResource/myResources/subscriptionFolder/son/subscriptionFolderSon_tpl.html',
                        controller: 'subscriptionFolderSonCtrl',
                    },
                },
            })
            .state('front.networksource.myresources.quickpreview', {
                url: '/quickpreview?groupid&searchtype&searchword&guid',
                views: {
                    'main@front.networksource.myresources': {
                        templateUrl: './networkResource/myResources/quickPreview/myResourcesQuickPreview_tpl.html',
                        controller: 'myResourcesQuickPreviewCtrl',
                    },
                },
            })
            .state('front.networksource.myresources.search', {
                url: '/search?searchtype&searchword&daterange',
                views: {
                    'main@front.networksource.myresources': {
                        templateUrl: './networkResource/myResources/subscriptionFolder/search/myResourcesSearch_tpl.html',
                        controller: 'myResourcesSearchCtrl',
                    },
                },
            })
            .state('front.networksource.myresources.searchquickpreview', {
                url: '/searchquickpreview?searchtype&searchword&indexname&daterange',
                views: {
                    'main@front.networksource.myresources': {
                        templateUrl: './networkResource/myResources/subscriptionFolder/search/quickPreview/myResourcesSearchQuickPreview_tpl.html',
                        controller: 'myResourcesSearchQickPreviewCtrl',
                    },
                },
            });
    },
]);
